/** Same-fragment navigation does not reload a page; boot auth explicitly in that case. */
export function resumeEmailLinkDestination(path: string, location: Pick<Location, 'origin' | 'href' | 'replace' | 'reload'> = window.location): void {
  const url = new URL(path, location.origin);
  const target = path.startsWith('/') && !path.startsWith('//') && url.origin === location.origin ? path : '/';
  if (new URL(target, location.origin).href === location.href) location.reload();
  else location.replace(target);
}
